import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('br'),_c('br'),_c(VRow,{attrs:{"no-gutters":""}},[_c(VCol,{attrs:{"cols":"12"}},[_c(VCard,{staticClass:"mx-auto",attrs:{"max-width":"300px","to":"/promociones/firma","flat":""}},[_c(VImg,{attrs:{"src":require("@/assets/img/promociones.jpeg"),"height":"300px"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }